import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

import {
  db
} from "../firebase";

import {
  doc,
  getDoc,
  collection,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";

import "../styles/BookRide.css";

export default function BookRide() {

  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const driver = location.state?.driver;

  const [loading, setLoading] = useState(false);

  const [customerName, setCustomerName] = useState("");
  const [customerMobile, setCustomerMobile] = useState("");

  const [pickup, setPickup] = useState("");
  const [destination, setDestination] = useState("");
  const [notes, setNotes] = useState("");

  useEffect(() => {

    if (!driver) {

      navigate("/autos");

      return;

    }

    loadUser();

  }, []);

  async function loadUser() {

    try {

      const snap = await getDoc(
        doc(db, "users", user.uid)
      );

      if (snap.exists()) {

        const data = snap.data();

        setCustomerName(data.name || "");
        setCustomerMobile(data.mobile || "");

      }

    } catch (err) {

      console.error(err);

    }

  }

  async function requestRide(e) {

    e.preventDefault();

    if (!pickup || !destination) {

      alert("Please enter pickup and destination.");

      return;

    }

    setLoading(true);

    try {

      await addDoc(
        collection(db, "rideRequests"),
        {

          customerUid: user.uid,

          customerName,

          customerMobile,

          driverUid: driver.uid,

          driverName: driver.driverName,

          driverMobile: driver.mobile,

          autoNumber: driver.autoNumber,

          pickup,

          destination,

          notes,

          status: "pending",

          createdAt: serverTimestamp(),

          acceptedAt: null,

          completedAt: null

        }
      );

      alert("🚖 Ride requested successfully.");

      navigate("/autos");

    }

    catch (err) {

      console.error(err);

      alert(err.message);

    }

    setLoading(false);

  }

  return (

    <div className="book-ride-page">

      <h2>🚖 Book Auto</h2>

      <div className="driver-card">

        <img
          src={
            driver.photo ||
            "https://via.placeholder.com/100"
          }
          alt=""
        />

        <div>

          <h3>{driver.driverName}</h3>

          <p>{driver.autoNumber}</p>

          <p>{driver.serviceArea}</p>

        </div>

      </div>

      <form
        className="ride-form"
        onSubmit={requestRide}
      >

        <input
          value={customerName}
          readOnly
        />

        <input
          value={customerMobile}
          readOnly
        />

        <input
          placeholder="Pickup Location"
          value={pickup}
          onChange={(e) =>
            setPickup(e.target.value)
          }
          required
        />

        <input
          placeholder="Destination"
          value={destination}
          onChange={(e) =>
            setDestination(e.target.value)
          }
          required
        />

        <textarea
          placeholder="Notes (Optional)"
          value={notes}
          onChange={(e) =>
            setNotes(e.target.value)
          }
          rows={4}
        />

        <button
          className="book-btn"
          disabled={loading}
        >

          {loading

            ? "Requesting..."

            : "Request Ride"}

        </button>

      </form>

    </div>

  );

}